import "core-js/modules/es6.number.constructor";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var PercentHelper =
/*#__PURE__*/
function () {
  function PercentHelper() {
    _classCallCheck(this, PercentHelper);
  }

  _createClass(PercentHelper, [{
    key: "GetPercentReadValue",
    value: function GetPercentReadValue(number) {
      if (typeof number === "string") number = Number(number);
      return parseFloat(number * 100 || 0).toFixed(2) + "%";
    }
  }]);

  return PercentHelper;
}();

export default new PercentHelper();